import React from 'react';

const Blog = () => {
    return (
        <div>
            <h1 className='text-center text-5xl text-red-600'>Comming Soooooon..........</h1>
        </div>
    );
};

export default Blog;